<!-- FULL APPLICATION SHELL -->

<div
    class="app-shell mat-app-background"
    [class.theme--dark]="themeService.isDarkTheme()"
    [class.theme--default]="!themeService.isDarkTheme()">
    <!-- Sidebar -->
    <entity-sidebar></entity-sidebar>

    <div class="app-main">
        <!-- Top navigation -->
        <dashboard-header-nav></dashboard-header-nav>

        <!-- Page content -->
        <div class="app-content mat-app-background">
            <router-outlet pulseSupportContext></router-outlet>
        </div>

        <!-- Global utilities -->
        <app-scroll-top></app-scroll-top>
        <loading></loading>
        <dashboard-popup-alert></dashboard-popup-alert>
        <alert-toast></alert-toast>
    </div>
</div>
